import {LoadState} from 'enums';
import {IDeviceModel, IDeviceModelAPI, IFirmware, IFirmwareAPI, IManufacturer, IManufacturerAPI} from 'interfaces';
// Not using index import for services to avoid circular dependency
import {axiosServer} from './API';

// Holds manufacturers, models, and firmware versions for devices.
class _CommandService {

    public pingDevice(id: number): Promise<any> {
        // Need to make sure info is loaded so mapping works.
        return axiosServer.get<IDeviceModel>(`/ping/${id}`)
            .then((resp) => {
                console.log(resp.data);
                return resp.data;
            })
            .catch((err) => {
                console.log('Error pinging device: ', err);
            });
    }

    public commandDevice(id: number): Promise<any> {
        // Need to make sure info is loaded so mapping works.
        return axiosServer.get<IDeviceModel>(`/command/${id}`)
            .then((resp) => {
                console.log(resp.data);
                return resp.data;
            })
            .catch((err) => {
                console.log('Error commanding device: ', err);
            });
    }
}

export const CommandService = new _CommandService();